import { API_URL } from "@/misc/constants";
import { get, put } from "./index";

const BASE = `${API_URL}/schedule`;
const BUCKET_BASE = `${BASE}/daySlotsBucket`;

const getMasterFreeSlots = (master, params) => {
  return get(`${BASE}/master/${master}/free`, { params, cache: false });
};
const getMasterBusySlots = (master, params) => {
  return get(`${BASE}/master/${master}/busy`, {
    params,
    cache: false,
  });
};
const createBucket = async (payload) => {
  const res = await put(BUCKET_BASE, payload);
  return res;
};
const createBucketBulk = async (payload) => {
  const res = await put(`${BUCKET_BASE}/bulk`, payload);
  return res;
};
const getBucket = (params) => {
  return get(BUCKET_BASE, {
    params,
    cache: false,
  });
};

export const ScheduleAPI = {
  getBucket,
  createBucket,
  createBucketBulk,
  getMasterFreeSlots,
  getMasterBusySlots,
};
